<div class="status-selector">
    <div class="status-container row" *ngIf="bulkQuoteError.length >0">
        <div class="col-3"><img src="../../../../assets/images/icon-error.svg" class="spriteNew" /></div>
        <div class="col-9 status-container-text"><span class="status-text">{{bulkQuoteError}}</span></div>
    </div>
</div>